import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { NgbAccordionModule } from '@ng-bootstrap/ng-bootstrap';

import { Accordion } from '@digital-platform/rs-cms/domain';
import { BasePTypeComponent } from '../base-ptype/base-ptype.component';

interface safeItems {
  title: string;
  body: SafeHtml;
}

@Component({
  selector: 'digital-platform-accordion',
  standalone: true,
  imports: [CommonModule, NgbAccordionModule],
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.scss'],
})
export class AccordionComponent
  extends BasePTypeComponent
  implements Accordion, OnInit
{
  constructor(private sanitizer: DomSanitizer) {
    super();
  }

  @Input() items: Accordion['accordionItems'] | undefined;
  @Input() title: string | null = null;
  public override type = 'accordion' as const;

  safeItems: safeItems[] | undefined = undefined;

  ngOnInit(): void {
    this.safeItems = this.items?.map((item) => ({
      title: item.title,
      body: this.sanitizer.bypassSecurityTrustHtml(item.body),
    }));
  }
}
